"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import salesProductPriceService from "@/services/sales-product-price.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetSalesProductPriceByIdReturn = RequestsBaseReturn<ISalesProductPrice | null>;

export type UseGetSalesProductPriceByIdProps = ByIdRequestProps;

type UseSwrGetSalesProductPriceByIdParams = [string, number];

const useGetSalesProductPriceById = ({
  _id,
}: UseGetSalesProductPriceByIdProps): UseGetSalesProductPriceByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ISalesProductPrice, Error, UseSwrGetSalesProductPriceByIdParams | null>(
    _id ? [SWR_KEYS.getSalesProductPriceById, _id] : null,
    ([, salesProductPriceId]) => salesProductPriceService.getById(salesProductPriceId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetSalesProductPriceById;
